import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { ThreeDots } from 'react-bootstrap-icons';
import BoostModalContainer from '../../../containers/Budget/Boost/BoostModalContainer';
import ShareContainer from '../../../containers/Share';
import { getFeatureByPath } from '../../routing/services';
import { PrivateComponent } from '../../permissions';
import { getFeatures } from '../../../redux/app/appActions';
import {
  getSplitTests,
  optimizeCampaigns
} from '../../../redux/overview/overviewActions';
import './TopBar.scss';

const TopBar: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const splitTestsList = useSelector(getSplitTests);
  const features = useSelector(getFeatures);
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState({
    target: '',
    isModalOpen: false
  });

  const handleClick = (currentTarget: string) => {
    setModal({
      isModalOpen: true,
      target: currentTarget
    });
  };

  const onCloseModal = () => {
    setModal({
      isModalOpen: false,
      target: ''
    });
  };

  return (
    <div className="overview-top-bar">
      <h4>{t('overview.page.name')}</h4>
      <>
        <Dropdown
          className="overview-actions"
          isOpen={isOpen}
          toggle={() => setIsOpen((prev) => !prev)}
          direction="down"
        >
          <DropdownToggle
            disabled={
              !getFeatureByPath(features, 'overview.boost') ||
              !getFeatureByPath(features, 'overview.share') ||
              !getFeatureByPath(features, 'overview.optimize')
            }
          >
            <ThreeDots />
          </DropdownToggle>
          <DropdownMenu>
            <PrivateComponent
              authorizationStrategy={() =>
                getFeatureByPath(features, 'overview.boost')
              }
            >
              <DropdownItem
                dataCy="overview-boost-button"
                onClick={() => handleClick('boost')}
                disabled={!splitTestsList?.length}
                className="overview-button"
              >
                {t('components.budget.boost.boost_button_label')}
              </DropdownItem>
              <BoostModalContainer
                isOpen={modal.target === 'boost'}
                onCancelAction={onCloseModal}
              />
            </PrivateComponent>
            <PrivateComponent
              authorizationStrategy={() =>
                getFeatureByPath(features, 'overview.share')
              }
            >
              <DropdownItem
                dataCy="overview-share-button"
                onClick={() => handleClick('share')}
                className="overview-button"
              >
                {t('components.share.share_button_label')}
              </DropdownItem>
              <ShareContainer
                isOpen={modal.target === 'share'}
                onCancelAction={onCloseModal}
              />
            </PrivateComponent>
            <PrivateComponent
              authorizationStrategy={() =>
                getFeatureByPath(features, 'overview.optimize')
              }
            >
              <DropdownItem
                data-cy-id="overview-optimize-button"
                onClick={() => dispatch(optimizeCampaigns())}
                disabled={!splitTestsList?.length}
                className="overview-button"
              >
                {t('components.optimize.optimize_button_label')}
              </DropdownItem>
            </PrivateComponent>
          </DropdownMenu>
        </Dropdown>
      </>
    </div>
  );
};

export default TopBar;
